import _ from 'lodash'
import graphUtil from './graphUtil'
import {geoMercator, geoPath as d3GeoPath} from 'd3-geo'
import {scaleLinear} from 'd3-scale'
import {select as d3Select} from 'd3-selection'
import 'd3-selection-multi'
// import fc_layout from 'd3fc-label-layout'

const moveToFront = function() {
  return this.each(function() {
    this.parentNode.appendChild(this)
  })
}

export const formatCountryName = name => {
  if (!name || name == null) {
    return
  }
  return name.trim().replace(/\s+/g, '_').toLowerCase() // Trim and replace spaces with underscores
}

const createDrawFunctions = (scale=80, transX=0, transY=0, d3Projection) => {
  if (!d3Projection) {
    d3Projection = geoMercator()
  }
  const projection = d3Projection
    .translate([transX, transY])
    .scale(scale)
  const geoPath = d3GeoPath()
    .projection(projection)
  return {projection, geoPath}
}

function _getDomain (collection, property) {
  return [
    _.min(collection, property)[property],
    _.max(collection, property)[property]
  ]
}

const _addGeoLayer = (svg, geoPath, layerData, applyNonScalingStroke) => {
  const boundaryG = svg.append('g').attrs({
    'class': 'geo_layer layer_' + layerData.className,
    'pointer-events': 'none'
  })
  if (layerData.className.indexOf('places') === -1) {
    // Lines
    const boundLines = boundaryG.selectAll("path.geo_bound_line")
      .data(layerData.features)

    boundLines.exit().remove()

    boundLines.enter()
      .append('path')
      .attrs({
        d: geoPath,
        // id: (d) => { return d.id }, // d.properties.name name can be multiple words, invalid html
        'class': 'geo_feature ' + layerData.className,
        'vector-effect': applyNonScalingStroke ? 'non-scaling-stroke' : null
      })
  } else {
    // Points
    const projection = geoPath.projection()

    const projectedData = _.map(layerData.features, d => {
      const coords = projection(d.geometry.coordinates)
      return {
        x: coords[0],
        y: coords[1],
        name: d.properties.NAME,
        pop: d.properties.POP_MAX,
        scaleRank: d.properties.SCALERANK
      }
    })

    const dotScale = scaleLinear()
      .domain(_getDomain(projectedData, 'pop'))
      .range([2, 4])

    // let fontScale = scaleLinear()
    //   .domain(_getDomain(projectedData, 'scaleRank'))
    //   .rangeRound([10, 20])


    // var labelPadding = 2;
    //
    // // the component used to render each label
    // var textLabel = fc_layout.textLabel()
    //   .padding(labelPadding)
    //   .value(function(d) {
    //     // return d.properties.name
    //     return d.name
    //   })
    //
    // // a strategy that combines simulated annealing with removal
    // // of overlapping labels
    // var strategy = fc_layout.removeOverlaps(fc_layout.greedy())
    //
    // // create the layout that positions the labels
    // var labels = fc_layout.label(strategy)
    //   .size(function(d) {
    //       // measure the label and add the required padding
    //     var textSize = d3.select(this)
    //       .select('text')
    //       .node()
    //       .getBBox()
    //     return [textSize.width + labelPadding * 2, textSize.height + labelPadding * 2]
    //   })
    //   .position(function(d) {
    //     // return projection(d.geometry.coordinates)
    //     return [d.x, d.y]
    //   })
    //   .component(textLabel)
    //
    // // render!
    // svg.datum(projectedData)
    //   .call(labels)


    let points = boundaryG.selectAll("g.geo_point")
      .data(projectedData)

    points.exit().remove()

    points = points.enter()
      .append('g')
      .attrs({
        transform: d => {
          // let projectedCoords = projection(d.geometry.coordinates)
          return `translate(${ d.x }, ${ d.y })`
        },
        'class': 'geo_feature ' + layerData.className,
        'vector-effect': applyNonScalingStroke ? 'non-scaling-stroke' : null
      })
      .merge(points)

    // Point dot
    const pointDots = points.selectAll("circle.geo_dot").data(d => [d])
    pointDots.exit().remove()
    pointDots.enter()
      .append('circle')
      .attrs({
        cx: 0,
        cy: 0,
        r: d => dotScale(d.pop),
        'class': 'geo_dot',
        'vector-effect': applyNonScalingStroke ? 'non-scaling-stroke' : null
      })

    // Text labels
    const pointText = points.selectAll("text.geo_text").data(d => [d])
    pointText.exit().remove()
    pointText.enter()
      .append('text')
      .attrs({
        x: 0,
        y: 0,
        dx: 2,
        dy: -2,
        opacity: 0,
        // 'font-size': d => fontScale(d.scaleRank),
        'class': d => `geo_text scale_rank_${ d.scaleRank }`,
        'vector-effect': applyNonScalingStroke ? 'non-scaling-stroke' : null
      })
      .text(d => d.name)

    // function arrangeLabels() {
    //   var move = 1
    //   while(move > 0) {
    //     move = 0
    //     svg.selectAll(".geo_text")
    //     .each(function() {
    //       var that = this
    //       var a = this.getBoundingClientRect()
    //       boundaryG.selectAll(".place-label")
    //       .each(function() {
    //         if (this != that) {
    //           var b = this.getBoundingClientRect()
    //           if((Math.abs(a.left - b.left) * 2 < (a.width + b.width)) &&
    //              (Math.abs(a.top - b.top) * 2 < (a.height + b.height))) {
    //             // overlap, move labels
    //             var dx = (Math.max(0, a.right - b.left) + Math.min(0, a.left - b.right)) * 0.01
    //             var dy = (Math.max(0, a.bottom - b.top) + Math.min(0, a.top - b.bottom)) * 0.02
    //             var tt = d3.transform(d3.select(this).attr("transform"))
    //             var to = d3.transform(d3.select(that).attr("transform"))
    //             move += Math.abs(dx) + Math.abs(dy)
    //
    //             to.translate = [ to.translate[0] + dx, to.translate[1] + dy ]
    //             tt.translate = [ tt.translate[0] - dx, tt.translate[1] - dy ]
    //             d3.select(this).attr("transform", "translate(" + tt.translate + ")")
    //             d3.select(that).attr("transform", "translate(" + to.translate + ")")
    //             a = this.getBoundingClientRect()
    //           }
    //         }
    //       })
    //     })
    //   }
    // }
    // arrangeLabels()
  }
}





const drawCountryData = (opts) => {
  const {svg, geoPath, countriesData, clickHandler, geoLayers, selectedCountryCodes, applyNonScalingStroke = false} = opts
  const countryG = svg.append('g').classed('geo_countries', true)

  let countrySelection = countryG.selectAll("path.geo_region_path")
    .data(countriesData, (d) => { return d.id })

  countrySelection.exit().remove()

  const newCountries = countrySelection.enter()
    .append('path')
    .attrs({
      d: geoPath,
      id: (d) => { return 'cc' + d.properties.iso_a2 || d.id },
      'class': (d) => {
        return [
          'geo_region_path',
          formatCountryName(d.properties.name),
        ].join(' ')
      },
      'vector-effect': applyNonScalingStroke ? 'non-scaling-stroke' : null,
      'data-tooltip': (d) => { return d.properties.name },
      'data-tooltip-follow': 'true'
    })

  if (clickHandler && clickHandler != null) {
    newCountries.on('click', (d) => {
      this.parentNode.appendChild(this) // move to front
      clickHandler(d)
      d3Select(this).classed('selected_country', true)
    })
  }

  if (geoLayers) {
    if (_.isArray(geoLayers)) {
      for (var i = 0; i < geoLayers.length; i++) {
        _addGeoLayer(svg, geoPath,  geoLayers[i], applyNonScalingStroke)
      }
    } else {
      _addGeoLayer(svg, geoPath, geoLayers, applyNonScalingStroke)
    }
  }

  countrySelection = newCountries.merge(countrySelection)

  // handle initial selected country codes
  if (selectedCountryCodes) {
    const isSelected = d => selectedCountryCodes.indexOf(d.properties.iso_a2 || d.id) !== -1
    countrySelection.classed('selected_country', isSelected)
    countrySelection.filter(isSelected).raise()
  }

  return countrySelection
}


// const drawRegionLabels = ({svg, graphOptions, geoPath, countriesData}) ->
//   labelSelection = svg.selectAll(".country_label")
//     .data(countriesData, (d) -> d.id)
//
//   labelSelection.exit().remove()
//
//   labelSelection.enter().append("text")
//     .attr("class", (d) ->
//       "country_label " + d.id
//     )
//     .attr("transform", (d) ->
//       "translate(" + geoPath.centroid(d) + ")"
//     )
//     .attr("dy", ".35em")
//     .text((d) ->
//       d.properties.name
//     )
//   labelSelection



// drawRegionButtons = (countryGroup, buttonGroup, graphOptions, drawFunctions,
// countriesData, countrySelection, regionData, drawRegionFunctions) ->
//   regions = ['na', 'latam', 'emea', 'apac']
//   rectGroup = buttonGroup.append('g')
//     .attrs
//       transform: "translate(#{-graphOptions.w / 2}, #{(graphOptions.h / 2) - 74})"
//   regionsEnter = rectGroup.selectAll('rect')
//     .data(regions)
//     .enter()
//   regionWidth = 109
//   regionHeight = 76
//   regionSpacing = 21
//   window.regionData = regionData
//   regionsEnter.append('rect')
//     .attrs(
//       x: (d, i) -> i * (regionWidth + regionSpacing)
//       stroke: '#fff'
//       height: regionHeight
//       width: regionWidth
//     )
//     .on('click', (regionName) ->
//       spliceCount = 0
//       countrySelection.each((d, i) ->
//         if d.isSelected
//           d.isSelected = d.isMouseover = false
//           regionData[regionName].push countriesData[i - spliceCount]
//           countriesData.splice (i - spliceCount), 1
//           spliceCount++
//       )
//       countrySelection = drawCountryData countryGroup, graphOptions,
//         drawFunctions.geoPath, countriesData
//       drawRegionFunctions.forEach (nextDrawFunction) -> nextDrawFunction()
//     )
//   regionsEnter.append('text')
//     .attrs(
//       x: (d, i) -> i * (regionWidth + regionSpacing) + (regionWidth / 2)
//       y: (d, i) -> regionHeight / 2
//       "text-anchor": "middle"
//       fill: '#fff'
//       stroke: 'none'
//     )
//     .style('pointer-events': 'none')
//     .text((d) -> d)

const createRegionOptions = (opts) => {
  const {regionName, maxX, minX, maxY, minY, padding, mapScale, mapProjection, regionDataPromise, preserveAspectRatio, dotScaleFactor} = opts
  const prjHeight = maxY - minY
  const prjWidth = maxX - minX
  const naGraphOptions = graphUtil.createBasicGraphOptions({
    h: prjHeight,
    w: prjWidth,
    allPadding: padding
  })
  return _.extend(naGraphOptions, {regionName, maxX, minX, maxY, minY, mapScale, mapProjection, regionDataPromise, preserveAspectRatio, dotScaleFactor})
}

// const initRegionViews = (regionOptions) => {
//   drawFunctions = []
//   regionOptions.forEach (nextRegionOptions, i) ->
//     {minX, maxX, minY, maxY, mapScale, mapProjection, padding,
//       regionData} = nextRegionOptions
//     regionDrawFunctions = createDrawFunctions mapScale, (-minX + padding.left),
//     (-minY + padding.top), mapProjection
//     rowHeight = 250
//     colWidth = 250
//     topPos = 100 + Math.floor(i / 2) * rowHeight
//     leftPos = 550 + (i % 2) * colWidth
//     $regionViewEl = $('<div></div>').css
//       height: "200px"
//       width: "200px"
//       position: 'absolute'
//       top: topPos
//       left: leftPos
//       margin: '0'
//       padding: 0
//       border: '1px solid white'
//       "background-color": '#303030'
//     $('#display').append $regionViewEl
//     svg2 = graphUtil.drawSvg $regionViewEl[0], nextRegionOptions
//     svg2.style
//       border: '1px solid white'
//     drawFunctions.push _.partial drawCountryData, svg2, nextRegionOptions, regionDrawFunctions.geoPath, regionData
//   drawFunctions
// }

export default { moveToFront, createDrawFunctions, drawCountryData, createRegionOptions }
